<template>
  <div>
    <span v-if="label" class="input-label"> {{ $t(label) }}</span>
    <small v-if="subLabel" class="subLabel"> {{ $t(subLabel) }}</small>
    <div class="mt-1">
      <v-text-field
        :class="customClass"
        :model-value="modelValue"
        color="primary"
        variant="outlined"
        :type="type"
        :disabled="disabled"
        loading-color="primary"
        :placeholder="placeholder ? $t(placeholder) : ''"
        :hint="hint"
        persistent-hint
        :readonly="readonly"
        @input="$emit('update:modelValue', $event.target.value)"
        @click:prepend="$emit('click:prepend')"
        :rules="rules"
        :hide-details="hideDetails"
        validate-on="blur"
        :append-icon="appendIcon"
        :prepend-icon="prependIcon"
        :prepend-inner-icon="prependInnerIcon"
        :append-inner-icon="appendInnerIcon"
        :prefix="prefix"
        :suffix="suffix"
        :density="density"
        :rounded="rounded"
        @keypress="handleKeypress"
        @paste="handlePaste"
        :bg-color="bgColor"
        v-bind="{ maxWidth: maxWidth || undefined }"
        :clearable="clearable"
        @click:clear="$emit('update:modelValue', '')"
      >
      </v-text-field>
    </div>
  </div>
</template>

<script setup>
import { pasteNumber, numbersOnly } from "@/utils/helpers/inputFormatter";

const props = defineProps({
  label: {
    type: String,
    default: "",
  },
  subLabel: {
    type: String,
    default: "",
  },
  modelValue: {
    type: [String, Number],
    default: "",
  },
  appendIcon: {
    type: String,
    default: "",
  },
  appendInnerIcon: {
    type: String,
    default: "",
  },
  prependIcon: {
    type: String,
    default: "",
  },
  prependInnerIcon: {
    type: String,
    default: "",
  },
  type: {
    type: String,
    default: "text",
  },
  placeholder: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  rules: {
    type: Array,
    default: [],
  },
  customClass: {
    type: String,
    default: "",
  },
  hint: String,
  isNumber: Boolean,
  hideDetails: {
    type: [Boolean, String],
    default: "auto"
  },
  isNewVersion: Boolean,
  density: {
    type: String,
    default: "default",
  },
  rounded: {
    type: String,
    default: "lg",
  },
  prefix: String,
  suffix: String,
  maxWidth: {
    type: String,
    required: false,
  },
  bgColor: String,
  clearable: Boolean,
  hint: String,
});

const handleKeypress = (event) => {
  if (props.isNumber) {
    numbersOnly(event);
  }
  if (props.type == "phone") {
    event = event ? event : window.event;
    var charCode = event.which ? event.which : event.keyCode;
    if (
      (charCode > 1775 && charCode < 1786) ||
      (charCode > 1631 && charCode < 1642) ||
      (charCode > 47 && charCode < 58)
    ) {
      return true;
    } else {
      event.preventDefault();
    }
  }
};

const handlePaste = (event) => {
  if (props.isNumber) {
    pasteNumber(event);
  }
  if (props.type == "phone") {
    event.preventDefault();
    const paste = (event.clipboardData || window.clipboardData).getData("text");
    const filteredPaste = paste.replace(/[^\d۰-۹]/g, ""); // Remove non-numeric characters
    document.execCommand("insertText", false, filteredPaste);
  }
};
</script>

<style lang="scss" scoped>
// .v-input:not(.v-input--error) .v-messages {
//   opacity: unset !important;
//   .v-messages__message {
//     color: rgb(var(--v-theme-grey4));
//   }
// }
</style>
